/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'
import { STORE_ADDRESS_FRAGMENT } from '../fragments/StoreAddressFragment'

export const GET_COMPANY_STORE_STATES_BY_IDS = gql`
  query GetCompanyStoreStatesByIds($input: CompanyStoresByIdsInput!) {
    companyStoresByIds(input: $input) {
      id
      address {
        ...StoreAddress
      }
    }
  }
  ${STORE_ADDRESS_FRAGMENT}
`
